// https://docs.microsoft.com/ja-jp/graph/api/resources/channel?view=graph-rest-1.0
export class Channel {
	public static parse(data: IChannel): Channel {
		const channel: Channel = new Channel();
		if (data.id !== undefined) {
			channel.id = data.id;
		}
		if (data.displayName !== undefined) {
			channel.displayName = data.displayName;
		}
		return channel;
	}
	public id: string = "";
	public displayName: string = "";
}

export interface IChannel {
	id?: string;
	displayName?: string;
}
